import React from "react";
import PropTypes from "prop-types";
import { X } from "lucide-react";

const CommonDialog = ({ open, onClose, title, children }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onClose}>
            <div
                className="w-[80%] md:w-[40%] max-w-2xl max-h-[84vh] bg-white rounded-lg shadow-xl overflow-y-auto animate-slideIn"
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-between items-center xl:p-2 2xl:p-4 3xl:p-4 border-b border-gray-200">
                    <h2 className="xl:text-sm 2xl:text-base 3xl:text-lg font-semibold text-primary">{title}</h2>
                    <button
                        onClick={onClose}
                        className="p-1 rounded-full text-primary hover:bg-red-50 transition-colors"
                    >
                        <X size={20} />
                    </button>
                </div>

                <div className="xl:p-2 2xl:p-4 3xl:p-4 xl:pt-4 2xl:pt-4 3xl:pt-6 xl:ml-2 2xl:ml-4 3xl:ml-4">
                    <div className="flex flex-col xl:gap-2 2xl:gap-4 3xl:gap-6">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

CommonDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default CommonDialog;